/* eslint-disable */


/**
 * Create styles for `<EditProfileDialog />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<EditProfileDialog />` styles
 */
const editProfileDialogStyles = ({ theme }) => ({
  appBar: {
    background: theme.palette.common.white,
    boxShadow: `none`,
    position: `relative`,
  },
  flex: {
    flex: 1,
  },
});

export default editProfileDialogStyles;
